import { render, staticRenderFns } from "./CircularTinplateBadge.vue?vue&type=template&id=4b4083c6&scoped=true&"
import script from "./CircularTinplateBadge.vue?vue&type=script&lang=js&"
export * from "./CircularTinplateBadge.vue?vue&type=script&lang=js&"
import style0 from "./CircularTinplateBadge.vue?vue&type=style&index=0&id=4b4083c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4083c6",
  null
  
)

component.options.__file = "CircularTinplateBadge.vue"
export default component.exports